import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'

import {
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle
} from '../../../ecosystemData/style'
import { SpecieParameterToggleWrapper, SpeciesDetailsContainer } from '../style'


const SpeciesParameterHeader = ({ item, isOpen, toggleAccordion }) => {
  return (
    <SpeciesDetailsContainer noPadding={true}>
      <EcosystemHeaderNavbarWrapper isOpen={isOpen}>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle>
            <FormattedMessage id={item.name} />
          </EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <SpecieParameterToggleWrapper isActive={isOpen}>
            <FormattedMessage id='expand' />
            {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
          </SpecieParameterToggleWrapper>
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
    </SpeciesDetailsContainer>
  )
}

export default SpeciesParameterHeader

SpeciesParameterHeader.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  isOpen: PropTypes.bool,
  toggleAccordion: PropTypes.func.isRequired
}

export { SpeciesParameterHeader }
